import { render, staticRenderFns } from "./motd.vue?vue&type=template&id=e4929680&scoped=true&"
import script from "./motd.vue?vue&type=script&lang=js&"
export * from "./motd.vue?vue&type=script&lang=js&"
import style0 from "./motd.vue?vue&type=style&index=0&id=e4929680&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4929680",
  null
  
)

export default component.exports